import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash';
import autobind from 'class-autobind';

export class HomepageVideo extends React.Component {
	changingPlayState = false;

	constructor(props) {
		super(props);
		autobind(this);
		this.ref = React.createRef();
	}

	componentDidMount() {
		const { isPlaying } = this.props;
		if (isPlaying) {
			this.playVideo();
		} else {
			this.pauseVideo();
		}
	}

	componentDidUpdate(prevProps) {
		const { isPlaying } = this.props;
		if (isPlaying && !prevProps.isPlaying) {
			this.playVideo();
		}
		if (!isPlaying && prevProps.isPlaying) {
			this.pauseVideo();
		}
	}

	async playVideo() {
		const { onPlay } = this.props;
		if (!this.changingPlayState) {
			try {
				this.changingPlayState = true;
				onPlay(this.ref.current);
				await this.ref.current.play();
				this.changingPlayState = false;
			} catch (err) {
				this.changingPlayState = false;
			}
		}
	}

	async pauseVideo() {
		const { onPause } = this.props;
		if (!this.changingPlayState) {
			try {
				this.changingPlayState = true;
				await this.ref.current.pause();
				onPause(this.ref.current);
				this.changingPlayState = false;
			} catch (err) {
				this.changingPlayState = false;
			}
		}
	}

	render() {
		const { asset, className } = this.props;
		return (
			<div>
				<video
					loop
					muted
					className={ className }
					poster={ get(asset.poster, 'asset.image') }
					ref={ this.ref }
				>
					<source src={ asset.asset.image } type="video/mp4" />
				</video>
			</div>
		);
	}
}

HomepageVideo.propTypes = {
	asset: PropTypes.object.isRequired,
	autoplay: PropTypes.bool,
	className: PropTypes.string,
	isPlaying: PropTypes.bool,
	onPause: PropTypes.func,
	onPlay: PropTypes.func
};

HomepageVideo.defaultProps = {
	autoplay: false,
	className: null,
	isPlaying: false,
	onPause: null,
	onPlay: null
};

export default HomepageVideo;
